const namespaced = true;

const getInitialState = () => ({
    configData: null,
    configPromise: null
});

const state = getInitialState();

const getters = {
    configData: state => state.configData,
    shippingOverweightThresholdLb: state => state.configData?.shipping_overweight_threshold_lb || 50,
    shippingOverweightSurchargeCents: state => state.configData?.shipping_overweight_surcharge_cents || 5000,
    minimumIosVersion: state => state.configData?.minimum_ios_version || null,
    maximumPickupBoxes: state => state.configData?.maximum_pickup_boxes || 20
};

const mutations = {
    SET_CONFIG_DATA: (state, payload) => {
        state.configData = payload;
    },
    SET_CONFIG_PROMISE: (state, payload) => {
        state.configPromise = payload;
    },
    RESET_STATE: state => {
        Object.assign(state, getInitialState());
    }
};

const actions = {
    FETCH_CONFIG: (context) => {
        if (context.state.configData) {
            return Promise.resolve(context.state.configData);
        }

        if (context.state.configPromise) {
            return context.state.configPromise;
        }

        const promise = window.api.call('config')
            .then(response => {
                context.commit('SET_CONFIG_DATA', response.data?.data || response.data);
                return response.data?.data || response.data;
            })
            .catch(error => {
                console.error('Error fetching config:', error);
                context.commit('SET_CONFIG_PROMISE', null);
                throw error;
            });

        context.commit('SET_CONFIG_PROMISE', promise);
        
        return promise;
    }
};

export default {
    namespaced,
    state,
    mutations,
    actions,
    getters
};
